export class AppConstants {

  public static Token = 'token'; // *summary: type: GetTokenViewModel

  public static RedirectState = 'redirectState'; // *summary: type

  public static DefaultBranch = 'defaultBranch'; // *summary: type: BranchModel
  public static BookingSelectedTreatment = 'selectedConsultation'; // *summary: type: RetrieveServicesAndPackagesByBranchViewModel
  public static SelectedPractitioner = 'selectedPractitioner'; // *summary: type: StaffDto
  public static BookingSelectedSlot = 'BookingSelectedSlot';
  public static BookingSelectedDate = 'BookingSelectedDate';
  public static BookingSelectedTime = 'BookingSelectedTime';
  public static BookingGiftVoucherNumber = 'BookingSelectedTime';
  public static BookingResultFailedToHoldGv = 'BookingResultFailedToHoldGv';
  public static BookingProcessStatus = 'BookingProcessStatus';
  public static BookingSelectedAppointmentForReschedule = 'BookingSelectedAppointmentForReschedule';   

  public static Appointment = 'appointment'; // *summary: type Appointment
  public static PendingTransaction = 'pendingTransaction'; // *summary: type Appointment

  public static Customer = 'customer'; // *summary: type: Customer
  public static Email = 'email'; // *summary: type

  public static AppointmentResult = 'appointmentResult'; // summary: Type AppointmentResult
  public static BookingTreatmentResult = 'BookingTreatmentResult';
  public static BookingPractionerResult = 'BookingPractionerResult';
  public static BookingSlotResult = 'BookingSlotResult';

  public static CustomerId = 'CustomerId';
  public static CustomerEmail = 'CustomerEmail';

  // Routes
  public static RouteSelectConsultation = 'select-consultation';
  public static RouteSelectPractitioner = 'select-practitioner';
  public static RouteSelectDate = 'select-date';
  public static RouteServiceConfirmation = 'service-confirmation';
  public static RouteGiftVoucherRedemption = 'gift-voucher-redemption';  
  public static RouteThankYou = 'thank-you';

  public static RouteInvalid = 'invalid';
  public static RouteCovid = 'covid';
  public static RouteTermsAndConditions = 'terms-and-conditions';

  public static RouteLogin = 'customer/login';
  public static RouteRegister = 'customer/register';
  public static RouteForgotPassword = 'customer/forgot-password';
  public static RouteResetPassword = 'customer/reset-password';
  public static RouteVerifyEmailAddress = 'customer/verify-email-address';
  public static RouteUpdateEmailAddress = 'customer/update-email-address';
  public static RouteMigrateCustomer = 'customer/activate-account';
  public static RouteChangePassword = 'customer/change-password';
  public static RouteProfile = 'customer/profile';
  public static RouteLogout = 'customer/logout';
  public static RouteTransactionHistory = 'customer/transaction-history';
  public static RouteIncomingAppointment = 'customer/future-bookings';
  public static RouteReSchedule = 'customer/reschedule';

  public static RouteGiftVouchers = 'gift-vouchers';            
  public static RouteGiftVoucher = 'add-to-basket';   
  public static RouteCart = 'cart'; 
  public static RouteCheckout = 'checkout';
  public static RouteGvThankYou = 'confirmation';

  public static GiftVoucherProcessStatus = 'GiftVoucherProcessStatus';
  public static GiftVoucherPendingTransactionHeader = 'GiftVoucherPendingTransactionHeader';
  public static GiftVoucherSelectedVoucher = 'GiftVoucherSelectedVoucher';
  public static GiftVoucherSelectedVouchers = 'GiftVoucherSelectedVouchers';
  public static GiftVoucherDownloadUrl = 'GiftVoucherDownloadUrl';
  public static GiftVoucherResultPendingTransactionHeader = 'GiftVoucherResultPendingTransactionHeader';
  public static GiftVoucherUrls = 'GiftVoucherUrls';

}
